import React from 'react';

import './description.styles.scss';

export const Description = ({logo, title, content}) => (
    <div className="post-description">
        <div className="container">
            {
                logo &&
                <img src={logo} alt={title} />
            }
            <h1>{title}</h1>
            <div dangerouslySetInnerHTML={{ __html: content}} />
        </div>
    </div>
)